export const COUNTRY_CODE_SPAIN = '011';
